import { render, staticRenderFns } from "./customTextArea.vue?vue&type=template&id=10f378fa&scoped=true&"
import script from "./customTextArea.vue?vue&type=script&lang=js&"
export * from "./customTextArea.vue?vue&type=script&lang=js&"
import style0 from "./customTextArea.vue?vue&type=style&index=0&id=10f378fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f378fa",
  null
  
)

export default component.exports